import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { provideConfig, provideFormioAppConfig } from './shared/services/config.service';
import { provideTranslation } from './shared/services/transloco.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(
            withInterceptors([authInterceptor])
        ),
        provideAnimationsAsync(),
        provideTranslation,
        provideConfig,
        provideFormioAppConfig,
    ],
};
